import { useContext, useEffect, useState } from 'react';

import { generateUniqueId } from '@client:common/misc';
import { Ripple } from '@client:common/effects/ripple';
import { Icon } from '@client:common/icon';

import { CheckboxProps, CHECKBOX_CONTEXT } from './common';

import './Checkbox.light.scss';
import './Checkbox.dark.scss';

export function Checkbox<T>(props: CheckboxProps<T>) {
  const { toggle } = useContext(CHECKBOX_CONTEXT);
  const [isChecked, setIsChecked] = useState(props.checked);
  const [id] = useState(generateUniqueId());
  const onIsCheckedChange = () => {
    toggle(props.value, props.index);
    setIsChecked(!isChecked);
    props.onChange();
  };

  useEffect(() => {
    setIsChecked(props.checked);
  }, [props.checked]);
  return (
    <div className='checkbox'>
      <div className='checkbox__square'>
        <Ripple
          fixed
          duration={1500} />
        <input
          className='checkbox__input'
          id={id}
          type='checkbox'
          name={props.name || id}
          checked={isChecked}
          onChange={onIsCheckedChange}
        />
        <Icon
          className='checkbox__icon checkbox__unchecked-icon'
          icon='check_box_outline_blank' />
        <Icon
          className='checkbox__icon checkbox__checked-icon'
          icon='check_box' />
        {props.intermediateState && (
          <Icon
            className='checkbox__icon checkbox__intermediate-icon'
            icon='indeterminate_check_box' />
        )}
      </div>
      <label
        className='checkbox__label'
        onClick={onIsCheckedChange}
        dangerouslySetInnerHTML={{ __html: props.label }}>
      </label>
      {props.children}
    </div>
  );
}
